import {DefaultModule, registerModule} from "../../builder/DashboardConfigServiceRegistry";

registerModule('ICP4AlphaEasternCreek', new class extends DefaultModule {
    overrideUIStrings() {
        return {
          "Asset Management": "SolarSense"
        }
      }
})